import React, { Fragment } from "react";
import ActionBar from "../../common/ActionBar";

const Dashboard = ({ breadcrumbs }) => {
  return (
    <Fragment>
      <ActionBar breadcrumbs={breadcrumbs} />
    </Fragment>
  );
};

export default Dashboard;
